import React from 'react';
import { BaseWidgetProps } from '../../utils/type';

import { getFormId } from '../../utils/tools';

export interface HiddenProps extends BaseWidgetProps {
  path?: string;
  dataBind: string;
  value: any;
  defaultValue: any;
}

const Hidden = (props: HiddenProps) => {
  const { value, defaultValue, _crengine = {} } = props;
  const { form, path, dataBind } = _crengine;
  const initialValue = (value || defaultValue);

  if (dataBind && form && initialValue) {
    return form.getFieldDecorator(getFormId(dataBind, path), {
      initialValue,
    })(
      <input type="hidden" />,
    );
  }

  return null;
};

export default Hidden;
